// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  env: 'test',
  hideConsole: false,
  production: false,
  applications: {
    fortify: {
      v2: 'https://test.fortifyv2.lcptracker.net',
      api: 'https://test.fortifyv2.lcptracker.net/api',
    },
  },
  authentication: {
    issuer: 'https://test.fortifyv2.lcptracker.net',
    redirectUrl: `${window.location.origin}/login/success`,
    postLogoutRedirectUri: `${window.location.origin}`,
    clientId: 'ContractorSpa',
    responseType: 'code',
    scope: 'email theidservertokenapi openid profile theidserveradminapi rbsApi offline_access',
    silentRenewUrl: 'https://test.fortifyv2.lcptracker.net/connect/token',
    renewTimeBeforeTokenExpiresValue: 300,
  },
  graphql: {
    gateway: {
      name: 'GatewayGraphQL',
      url: 'https://lcp-gateway-test-appsvs.azurewebsites.net/graphql/',
    },
    contractor: {
      name: 'ContractorGraphQL',
      url: 'https://lcp-contractor-test-appsvs.azurewebsites.net/graphql/',
    },
    project: {
      name: 'ProjectGraphQL',
      url: 'https://lcp-project-test-appsvs.azurewebsites.net/graphql/',
    },
    rbs: {
      name: 'RBSGraphQL',
      url: 'https://lcp-rbs-test-appsvs.azurewebsites.net/graphql/',
    },
    wageData: {
      name: 'WageGraphQL',
      url: 'https://lcp-wagedata-test-appsvs.azurewebsites.net/graphql/',
    },
  },

  userPortalHost: 'https://userportaltest.fortifyv2.lcptracker.net/',
  userPortalSso: 'https://userportaltest.fortifyv2.lcptracker.net/login/sso',
  smartClientURL: 'https://test-apim.lcptracker.net/smartclientapi',
};

/*

 * For easier debugging in development mode, you can import the following file

 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.

 * This import should be commented out in production mode because it will have a negative impact

 * on performance if an error is thrown.

 */

// import 'zone.js/plugins/zone-error';
// Included with Angular CLI.Collapse
